

































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
import { getColor, getFromSourceText, fromSourceList } from "@/libs/colors";

import Add from "./user_add.vue";

import UserPlayerModal from "@/views/users/detail_user_modal.vue";

@Component({
  components: {
    Add,
    UserPlayerModal
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  type: string = "user";

  userId: number = 0;

  userPlayerModalVisible: boolean = false;

  dispatchType = "stadium/users";

  deleteConfirmContent = "确认删除该球友吗？";

  dispatchTypeDelete = "stadium/deleteUser";

  fromSourceList = fromSourceList;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "user_name" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "注册时间", dataIndex: "created_time", sorter: true },
    {
      title: "球友添加",
      key: "player_count",
      scopedSlots: { customRender: "player_count" },
      sorter: true
    },
    {
      title: "Taisam添加",
      key: "player_count1",
      scopedSlots: { customRender: "player_count1" },
      sorter: true
    },
    { title: "来源", scopedSlots: { customRender: "from_source" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showUserPlayerModal(e: any, user_id: number, type: string) {
    this.userId = user_id;
    this.type = type;
    this.userPlayerModalVisible = true;
  }

  hideUserPlayerModal() {
    this.userPlayerModalVisible = false;
  }

  getColor(fromSource: number): string {
    return getColor(fromSource);
  }

  getFromSourceText(fromSource: number): string {
    return getFromSourceText(fromSource);
  }

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
